module.exports = __webpack_public_path__ + "static/media/mcm4.83c74e82.PNG";